module.exports = __webpack_public_path__ + "static/img/anxun42.df6e811a.png";